import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { DEALER } from "@/data/dealer";

export const Stars = ({ className }) => (
  <div className={cn("flex gap-1", className)} role="img" aria-label="5 out of 5 stars">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className="h-5 w-5 fill-current" aria-hidden="true" />
    ))}
  </div>
);

export const RatingBlock = ({ dark }) => (
  <div data-testid="rating-block">
    <div className="flex items-end gap-5">
      <p className="font-display text-[5.5rem] font-extrabold leading-[0.82] tracking-tight sm:text-[7rem]" data-testid="rating-score">
        {DEALER.rating.score}
      </p>
      <div className="pb-1.5">
        <Stars className={dark ? "text-white" : "text-ink"} />
        <p className={cn("mt-2 text-sm", dark ? "text-zinc-300" : "text-steel")}>out of 5 on AutoTrader</p>
      </div>
    </div>
    <p className="mt-6 text-lg font-semibold" data-testid="rating-review-count">
      From {DEALER.rating.reviews} customer reviews
    </p>
    <p className={cn("mt-2 max-w-md text-sm leading-relaxed", dark ? "text-zinc-400" : "text-steel")}>
      Rating and review count as shown on YK Motors' AutoTrader profile on {DEALER.rating.checked}.
    </p>
  </div>
);

export const PromoGraphics = () => (
  <div className="grid gap-4 sm:grid-cols-[1.09fr_1.5fr]" data-testid="promo-graphics">
    <figure className="overflow-hidden rounded-lg border border-white/10 bg-white">
      <img src="/brand/promo-5star.jpg" alt="YK Motors promotional graphic: AutoTrader 5 star rated dealer, over 100 customer reviews" loading="lazy" width={1280} height={1175} className="h-full w-full object-cover" />
    </figure>
    <figure className="overflow-hidden rounded-lg border border-white/10 bg-[#F5F5F5]">
      <img src="/brand/promo-highly-rated.jpg" alt="YK Motors promotional graphic: AutoTrader Highly Rated for customer service 2024, 2025 and 2026" loading="lazy" width={1280} height={853} className="h-full w-full object-contain" />
    </figure>
  </div>
);
